module.exports = __webpack_public_path__ + "static/media/icon_user.cac26e47.png";